define("shared/components/shared/link", ["exports", "@ember/component", "@ember/debug", "@ember/object", "@ember/utils", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _debug, _object, _utils, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/object",0,"@ember/utils",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <a
    href={{@href}}
    target={{if this.openInNewTab "_blank" "_self"}}
    rel={{if this.openInNewTab "noopener" ""}}
    data-test-id="link"
    ...attributes
    {{did-insert this.verifyAttrs}}
    {{did-update this.verifyAttrs @href @text}}
  >
    {{#if (has-block)}}
      {{yield}}
    {{else}}
      {{this.verifiedText}}
    {{/if}}
    {{#if this.openInNewTab}}
      <span class="u--screenReaderOnly" data-test-id="screen-reader-only">
        {{t "app.opens_in_new_tab"}}
      </span>
    {{/if}}
  </a>
  */
  {
    "id": "GOmBbyVr",
    "block": "[[[11,3],[16,6,[30,1]],[16,\"target\",[52,[30,0,[\"openInNewTab\"]],\"_blank\",\"_self\"]],[16,\"rel\",[52,[30,0,[\"openInNewTab\"]],\"noopener\",\"\"]],[24,\"data-test-id\",\"link\"],[17,2],[4,[38,1],[[30,0,[\"verifyAttrs\"]]],null],[4,[38,2],[[30,0,[\"verifyAttrs\"]],[30,1],[30,3]],null],[12],[1,\"\\n\"],[41,[48,[30,4]],[[[1,\"    \"],[18,4,null],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[30,0,[\"verifiedText\"]]],[1,\"\\n\"]],[]]],[41,[30,0,[\"openInNewTab\"]],[[[1,\"    \"],[10,1],[14,0,\"u--screenReaderOnly\"],[14,\"data-test-id\",\"screen-reader-only\"],[12],[1,\"\\n      \"],[1,[28,[35,5],[\"app.opens_in_new_tab\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13]],[\"@href\",\"&attrs\",\"@text\",\"&default\"],false,[\"if\",\"did-insert\",\"did-update\",\"has-block\",\"yield\",\"t\"]]",
    "moduleName": "shared/components/shared/link.hbs",
    "isStrictMode": false
  });
  /**
   * @module Components
   */
  /**
   * @class Shared::Link
   * @extends Component
   *
   * This component renders an anchor (<a ...>) tag that opens in a new tab by default.
   * While it expects an @href argument and will throw an exception if one is not provided,
   * it assumes that the actual URL is properly formatted, and won't apply any validations or
   * transformations on the URL itself.
   *
   * All HTML Attributes (class, aria-*, data-*, etc.) are automatically applied to the rendered <a ...> tag
   * and are valid attributes on this component.
   *
   *  Arguments:
   * - href (String) The URL to open
   * - [text] (String) Text to display on the link. Required and only applies to inline usage.
   * - [openInNewTab] (Boolean=true) Whether or not to open the link in a new tab.
   *
   * Examples:
   *
   * Simple Usage:
   * ```
   * <Shared::Link @href="https://google.com" @text="Click Me" />
   * ```
   *
   * Triggering an action:
   * ```
   * <Shared::Link
   *  @href="https://google.com" @text="Click Me"
   *  {{on "click" (action "someAction")}}
   * />
   * ```
   *
   * In the above example, "someAction" will receive the Event,
   * which can be used to `preventDefault`.
   *
   * Inline Usage with all options:
   * ```
   * <Shared::Link
   *  class="o--btn--lg o--btn--outline o--btn--block"
   *  data-test-id="specific-instance"
   *  @href="https://google.com"
   *  @text="Click Me"
   *  @openInNewTab={{false}}
   * />
   * ```
   *
   * Block Usage:
   * ```
   * <Shared::Link
   *  @href="https://google.com"
   * />
   *    Any Text or HTML
   * </Shared::Link>
   * ```
   */
  let LinkComponent = _exports.default = (_class = class LinkComponent extends _component2.default {
    get openInNewTab() {
      return this.args.openInNewTab ?? true;
    }
    get verifiedText() {
      (false && !((0, _utils.isPresent)(this.args.text)) && (0, _debug.assert)('The `@text` argument is required with inline usage', (0, _utils.isPresent)(this.args.text)));
      (false && !(typeof this.args.text === 'string') && (0, _debug.assert)('The `@text` argument must be a string', typeof this.args.text === 'string'));
      return this.args.text;
    }
    verifyAttrs() {
      (false && !((0, _utils.isPresent)(this.args.href)) && (0, _debug.assert)('A valid `@href` argument must be provided', (0, _utils.isPresent)(this.args.href)));
      (false && !(typeof this.args.href === 'string') && (0, _debug.assert)('The `@href` argument must be a string', typeof this.args.href === 'string'));
    }
  }, (_applyDecoratedDescriptor(_class.prototype, "verifyAttrs", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "verifyAttrs"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, LinkComponent);
});